import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Community } from '../../shared/community/components/community/community';

@Component({
  selector: 'app-entrar-na-comunidade',
  imports: [Community],
  templateUrl: './entrar-na-comunidade.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EntrarNaComunidadeComponent {}
